import { reactive } from 'vue';
import Cookies from 'js-cookie';
import _ from 'lodash';

export const auth = {
    session: reactive({
        token: '',
        user: {},
        isAdmin: false,
    }),

    clearSession: function() {
        Cookies.remove('session_id');
        this.session = {
            token: '',
            user: {},
            isAdmin: false,
        };
    },

    logout: async function() {
        await fetch(`/api/logout`, {
            method: 'POST',
            headers: {},
            credentials: 'same-origin',
        });
        this.clearSession();
    },

    isLoggedIn: async function() {
        await this.getSession();
        return !!this.session.token;
    },

    login: async function({ email, password }) {
        let res = await fetch(`/api/login`, {
            method: 'POST',
            headers: {},
            credentials: 'same-origin',
            body: JSON.stringify({ email, password }),
        });
        res = await res.json();
        if (res.errors) {
            console.log(res);
            let error = _.get(res, 'errors[0].extensions.code', 'Authentication Error');
            return { error };
        }

        Cookies.set('session_id', res.loginUser.token, { expires: 7 });
        return res;
    },

    getSession: async function() {
        let token = Cookies.get('session_id');
        if (!token) {
            this.clearSession();
            return;
        }

        let res = await fetch(`/api/auth`, {
            method: 'POST',
            headers: {},
            credentials: 'same-origin',
        });
        res = await res.json();

        this.session = Object.assign({}, this.session, {
            token,
            user: res.myAuth.user,
            isAdmin: res.myAuth.user.role === 'ADMIN',
        });
    },
};
